import React from "react";
import { createPortal } from "react-dom";
import * as S from "../../constants/StringConstants";

interface PageContainerProps {
  enableSave: boolean;
  saveTooltip?: string;
  onCancel: () => void;
  children: React.ReactNode;
  isReadonly?: boolean;
}

export const PageContainerButtons = ({ children }) => {
  const el = document.getElementById("app-builder__extra_action_buttons") as HTMLElement;
  return el && createPortal(children, el);
};

export const PageContainer = (props: PageContainerProps) => (
  <div className="app-builder__page">
    <div {...{ inert: props.isReadonly ? "" : undefined }}>{props.children}</div>
    <div className="app-builder__action_buttons">
      {!props.isReadonly ? (
        <>
          {/* empty div used by other components to add extra action buttons, do not remove */}
          <div id="app-builder__extra_action_buttons" />
          <button className="button-v2 button-v2__secondary" onClick={props.onCancel}>
            {S.APP_CANCEL_BUTTON}
          </button>
          <button
            className="button-v2 button-v2__primary"
            disabled={!props.enableSave}
            type="submit"
            title={props.saveTooltip}>
            {S.APP_SUBMIT_BUTTON}
          </button>
        </>
      ) : (
        <>
          <button className="button-v2 button-v2__secondary" onClick={props.onCancel}>
            {S.APP_CANCEL_BUTTON}
          </button>
        </>
      )}
    </div>
  </div>
);
